import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { 
  BackButtonArrow,  
  DynamicPlayerBadge, 
  RemovePlayerFromTeamModal, 
  TeamsListModal, 
  Dropdown
} from "@myplay/ui";

import ConfirmModal from './ConfirmModal';
import { CoachTeamsTable, HeaderTiles } from '..';
import { COACH, OPERATOR } from '../../utils/constants';
import './SingleCoach.scss';

const accountTypes = [COACH, OPERATOR];

const SingleCoach = ({ coach, onBack, CoachesStore, TeamsStore })=> {
  const [teamToDeleteFrom, setTeamToDeleteFrom] = useState(null);
  const [shouldDisplayAssignTeamModal, setAssignTeamModal] = useState(false);
  const [shouldDisplayConfirmModal, setShouldDisplayConfirmModal] = useState(false);
  const { avatar, avatarBgColor, fullName, firstName, lastName, teams, accountType } = coach;

  const handleCloseRemoveCoachModal = ()=> {
    setTeamToDeleteFrom(null);
  };

  const handleApproveDeleteCoach = async ()=> {
    await CoachesStore.removeTeamFromCoach(coach, teamToDeleteFrom);
    setTeamToDeleteFrom(null);
  };

  const handleRemoveCoachFromTeam = team => {
    setTeamToDeleteFrom(team);
  };

  const handleAssignTeam = ()=> {
    setAssignTeamModal(true);
  };

  const handleCloseTeamsListModal = ()=> {
    setAssignTeamModal(false);
  };

  const handleTeamSelect = team => {
    CoachesStore.attachCoachToTeam(coach, team);
    setAssignTeamModal(false);
  };

  const handleAccountTypeSelect = accountType => {
    if (accountType === OPERATOR) {
      setShouldDisplayConfirmModal(true);
    }
  };

  const handleChangeAccoutType = async () =>  {
    await CoachesStore.changeAccoutType(coach);
    setShouldDisplayConfirmModal(false);
  }

  return (
    <div className="single-coach" data-testid="single-coach">
      <div className="single-coach__header">
        <div className="single-coach__header__main">
          <div className="single-coach__header__main__coach-details">
            <DynamicPlayerBadge 
              avatarBgColor={avatarBgColor}
              avatar={avatar}
              firstName={firstName}
              lastName={lastName}
              badgeSize={60}
            />
            <span className="single-coach__header__main__coach-details__name">{fullName}</span>
          </div>
          {accountType === COACH ? 
            <Dropdown 
              items={accountTypes}
              selectedItem={COACH}
              onSelect={handleAccountTypeSelect}
            /> :
            <span>{accountType}</span>
          }
          <BackButtonArrow onClick={onBack}/>
        </div>
        <HeaderTiles />
      </div>
      <CoachTeamsTable 
        teams={teams}
        onRemoveCoachFromTeam={handleRemoveCoachFromTeam}
        onAssignTeam={handleAssignTeam}
      />
      {teamToDeleteFrom &&
        <RemovePlayerFromTeamModal
          isVisible={teamToDeleteFrom}
          name={fullName}
          teams={[teamToDeleteFrom]}
          onClose={handleCloseRemoveCoachModal}
          onApprove={handleApproveDeleteCoach}
        />
      }
      {shouldDisplayAssignTeamModal &&
        <TeamsListModal 
          isVisible={shouldDisplayAssignTeamModal}
          teams={TeamsStore.teams}
          onClose={handleCloseTeamsListModal}
          onTeamSelect={handleTeamSelect}
        />
      }
      <ConfirmModal 
        name={fullName}
        isVisible={shouldDisplayConfirmModal}
        onApprove={handleChangeAccoutType}
        onDismiss={()=> setShouldDisplayConfirmModal(false)}
      />
    </div>
  );
};

SingleCoach.propTypes = {
  coach: PropTypes.object, 
  CoachesStore: PropTypes.object, 
  onBack: PropTypes.func, 
  TeamsStore: PropTypes.object
};

SingleCoach.defaultProps = {
  coach: {}, 
  CoachesStore: {}, 
  onBack: ()=> {}, 
  TeamsStore: {}
};

export default inject("MetricsStore", "CoachesStore", "TeamsStore")(observer(SingleCoach));